import React, { useEffect, useReducer, useState } from 'react';
import { IconButton, Tabs, Tab } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@material-ui/icons/Cancel';
import MuiPhoneNumber from 'material-ui-phone-number';
import { formDataValidate } from '../../../../../utils/formUtils';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomSelect from '../../../../../shared/form-controls/custom-select/Custom-Select';
import {
  allRestaurantSelector,
  allHotelsSelector,
  fetchAllRestaurant,
} from '../../../../property/propertySlice';
import FooterButton from '../../FooterButton';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import { CHEF_TYPE } from '../../../../../constants/restaurantConst';
import {
  decodeMediaKeyValue,
  renderVideos,
  renderGifs,
  toMediaContent,
  processGifsForUpload,
} from '../../../../../utils/mediaUtils';
import {
  createChef,
  updateChefDetails,
  getPreSignedUrl,
} from '../../../../../utils/PropertyAPIUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';
import { ASSET_TYPE_PROPERTY } from '../../../../../constants/PropertyConst';
import { convertFileToBase64 } from '../../../../../utils/commonUtils';
import { ASSET_URL } from '../../../../../env/Configurations';

const ChefCreate = (props) => {
  const { toggleDrawer, chef, hotelId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const allRestaurantList = useSelector(allRestaurantSelector);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [rawImages, setRawImages] = useState([]);
  const [countryCode, setCountryCode] = useState('');
  const originalHotels = useSelector(allHotelsSelector);
  const [rawVideos, setRawVideos] = useState([]);
  const [rawGifs, setRawGifs] = useState([]);
  const [videoImageUrl, setVideoImageUrl] = useState('');
  const [gifImageUrl, setGifImageUrl] = useState('');
  const [hasVideoError, setHasVideoError] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isGifLoading, setIsGifLoading] = useState(false);
  const groupId = originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    restaurantId: {
      value: '',
      fieldName: 'Restaurant',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    designation: {
      value: '',
      fieldName: 'Designation',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    specisalisation: {
      value: '',
      fieldName: 'Specialisation',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    signatureDish: {
      value: '',
      fieldName: 'Signature Dish',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    email: {
      value: '',
      fieldName: 'Email Id',
      errors: {},
      validations: ['validEmail'],
      tab: 0,
    },
    phone: {
      value: '',
      fieldName: 'Phone Number',
      errors: {},
      validations: [],
      tab: 0,
      maxLimit: 10,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 1,
    },
    videos: {
      value: [],
      fieldName: 'Videos',
      errors: {},
      validations: [],
      tab: 1,
    },
    gifs: {
      value: [],
      fieldName: 'GIFs',
      errors: {},
      validations: [],
      tab: 1,
    },
  });

  useEffect(() => {
    if (chef?.id) {
      const currFields = { ...formData };

      // Populate form fields individually
      if (chef.restaurantId) currFields.restaurantId.value = chef.restaurantId;
      if (chef.name) currFields.name.value = chef.name;
      if (chef.designation) currFields.designation.value = chef.designation;
      if (chef.specisalisation) currFields.specisalisation.value = chef.specisalisation;
      if (chef.signatureDish) currFields.signatureDish.value = chef.signatureDish;
      if (chef.description) currFields.description.value = chef.description;
      if (chef.email) currFields.email.value = chef.email;
      if (chef.phone) currFields.phone.value = chef.phone;

      currFields.images.value = chef.images || [];

      const { Video: videoMediaContent, GIF: gifMediaContent } = decodeMediaKeyValue(
        chef.mediaContent,
      );
      const videoData = videoMediaContent || chef.videos || {};
      const gifData = gifMediaContent || chef.gifs || {};

      setVideoImageUrl(videoData.imageUrl || '');
      setGifImageUrl(gifData.imageUrl || '');

      setRawVideos(renderVideos(videoData));
      setRawGifs(renderGifs(gifData));

      setFormData(currFields);
    }
  }, [chef]);


  const handleSubmit = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const language = lang !== 'en' ? lang : '';
      e.preventDefault();
      toggleDrawer('', false, '');
      setLoading(true);
      const images = await getProcessedImages(
        rawImages,
        originalHotels?.find((hotel) => hotel?.id === hotelId)?.groupId,
        CHEF_TYPE,
        hotelId,
      );

      const gifData = await processGifsForUpload({
        rawGifs,
        groupId,
        propertyType: CHEF_TYPE,
        hotelId,
      });

      const mediaContent = toMediaContent({
        videoList: rawVideos,
        videoImageUrl,
        gifList: gifData,
        gifImageUrl,
      });

      const payload = {
        restaurantId: formData.restaurantId.value,
        name: formData.name.value,
        designation: formData.designation.value,
        specisalisation: formData.specisalisation.value,
        signatureDish: formData.signatureDish.value,
        description: formData.description.value,
        email: formData.email.value,
        phone: formData.phone.value,
        images,
        mediaContent,
        videos: { imageUrl: videoImageUrl || '' }, // minimal legacy field
        gifs: { imageUrl: gifImageUrl || '' },
        hotelId,
      };
      if (chef?.id) {
        payload.id = chef.id;
        await updateChefDetails(payload, language);
        notificationManager('success', 'Chef updated successfully');
      } else {
        await createChef(payload, language);
        notificationManager('success', 'Chef created successfully');
      }
      dispatch(fetchAllRestaurant(hotelId));
      setLoading(false);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : 'Error occurred while creating the Chef',
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const onNextClick = () => {
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };
  const handlePhoneNoChange = (phone, country) => {
    setCountryCode(country?.countryCode);
    const currField = { ...formData }.phone;
    if (
      phone?.startsWith(`+${country?.dialCode}`) &&
      phone?.length === country?.dialCode?.length + 1
    ) {
      currField.value = '';
    } else {
      currField.value = phone;
    }

    setFormData({ ...formData, phone: currField });
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const next = [...formData.images.value];
    next.splice(index, 1);
    setFormData({ images: { ...formData.images, value: next } });
  };

  useEffect(() => {
    formData.email.validations = formData.email.value ? ['validEmail'] : [];
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    if (
      tabValue === 0 &&
      !currTabFromData?.email?.errors?.required &&
      !currTabFromData?.email?.errors?.validEmail &&
      formData?.phone?.value !== ''
    ) {
      setIsTabInValid(formData?.phone?.value?.length < 10);
    } else {
      setIsTabInValid(!isValid);
    }
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-8'>
            <span className='page-title'>{chef ? 'Edit Chef' : 'Add Chef'}</span>
          </div>
          <div className='col-md-3'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='hotel-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Details' />
              <Tab label='Media' />
            </Tabs>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          {tabValue === 0 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Details</h4>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomSelect
                    item={formData.restaurantId}
                    handleInputChange={(e) => {
                      setFormData({ restaurantId: e });
                    }}
                    labelField='name'
                    valueField='id'
                    options={allRestaurantList}
                    labelPrefix='Select'
                    hideNullOption={allRestaurantList.length}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.name}
                    handleInputChange={(e) => {
                      setFormData({ name: e });
                    }}
                    multiline={true}
                    endAdornment={true}
                    characterCount={true}
                    maxLength={100}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.designation}
                    handleInputChange={(e) => {
                      setFormData({ designation: e });
                    }}
                    endAdornment={true}
                    characterCount={true}
                    maxLength={50}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.specisalisation}
                    handleInputChange={(e) => {
                      setFormData({ specisalisation: e });
                    }}
                    endAdornment={true}
                    characterCount={true}
                    maxLength={50}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.signatureDish}
                    handleInputChange={(e) => {
                      setFormData({ signatureDish: e });
                    }}
                    endAdornment={true}
                    characterCount={true}
                    maxLength={50}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 mb-3'>
                  <CustomTextField
                    item={formData.description}
                    handleInputChange={(e) => {
                      setFormData({ description: e });
                    }}
                    multiline={true}
                    endAdornment={true}
                    characterCount={true}
                    maxLength={500}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <CustomTextField
                    item={formData.email}
                    handleInputChange={(e) => {
                      setFormData({ email: e });
                    }}
                    multiline={true}
                  />
                </div>
                <div className='col-md-6 mb-3'>
                  <MuiPhoneNumber
                    name='phone'
                    label='Phone Number'
                    data-cy='user-phone'
                    defaultCountry={countryCode || 'in'}
                    disableAreaCodes
                    autoFormat={true}
                    countryCodeEditable={false}
                    value={formData?.phone?.value}
                    className='col-md-12'
                    error={formData?.phone?.errors?.required || false}
                    helperText={formData?.phone?.errors?.required}
                    onChange={(phone, country) => handlePhoneNoChange(phone, country)}
                    sx={{ '& svg': { height: '1.2rem' } }}
                  />
                </div>
              </div>
            </div>
          )}
          {tabValue === 1 && (
            <div className='col-md-12 mb-3'>
              <h4 className='tab-title'>Media</h4>
              <ImageUpload
                uploadedImages={formData.images.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setLoading(status);
                }}
                videoImageUrl={videoImageUrl}
                onVideoImageUrlChange={setVideoImageUrl}
                gifImageUrl={gifImageUrl}
                onGifImageUrlChange={setGifImageUrl}
                videoList={rawVideos}
                gifList={rawGifs}
                onVideoListUpdated={setRawVideos}
                onGifListUpdated={setRawGifs}
                hotelId={hotelId}
                groupId={groupId}
                propertyType={CHEF_TYPE}
                onVideoError={setHasVideoError}
                onThumbnailUploading={setIsThumbnailUploading}
                onVideoLoading={setIsVideoLoading}
                onGifLoading={setIsGifLoading}
              />
            </div>
          )}
        </div>
        <FooterButton
          onNextClick={onNextClick}
          handleSubmit={handleSubmit}
          onCancel={onCancel}
          loading={loading}
          maxtab={1}
          tabValue={tabValue}
          isUpdate={chef?.id}
          isTabInValid={isTabInValid}
          hasVideoError={hasVideoError}
          isThumbnailUploading={isThumbnailUploading}
          isVideoLoading={isVideoLoading}
          isGifLoading={isGifLoading}
        />
      </div>
    </form>
  );
};

export default ChefCreate;
